import React, {useEffect} from 'react';
import useHandleError from "@Errors/hooks/useHandleError";
import {isNotEmpty} from "@Array/isNotEmpty";
import FaqPortal from "@Features/faq/components/FaqPortal";
import BestPriceRouteType from "@Pages/stationToStation/types/BestPriceRoute.type";
import BestPriceOnDatePortal from "@Pages/stationToStation/components/BestPriceOnDatePortal";
import ReviewsPortal from "@Pages/reviewWidget/components/ReviewsPortal";
import DepartureAndDestinationStation from "@Pages/stationToStation/components/DepartureAndDestinationStation";
import GbtVehiclesPortal from "@Features/getByTransfer/components/GbtVehiclesPortal";
import ErrorBoundary from "@Errors/components/ErrorBoundary"
import permalinkTypeId from "@/constants/PermalinkTypeId";
import TableOfContentsPortal from "@Features/tableOfContents/components/TableOfContentsPortal";
import toggleStaticMainContentElements from "@Features/domElements/functions/toggleStaticMainContentElements";
import {CompanyCards} from "@Pages/stationToStation/components/CompanyCards";
import PortalMap from "@Portals/components/PortalMap";
import {TravelTable} from "@Pages/stationToStation/features/travelTable/components/TravelTable";

function StationToStation() {
    toggleStaticMainContentElements(true)
    const isStationToStation = window.permalinkTypeId === permalinkTypeId.stationToStation
    const stationToStationHasResults = isStationToStation
        && !!window?.bestPriceOnDateData
        && isNotEmpty((window?.bestPriceOnDateData as Record<number, BestPriceRouteType[]>)[1])

    const isPortToPort = window.permalinkTypeId === permalinkTypeId.portToPort
    const portToPortHasResults = isPortToPort
        && isNotEmpty(window?.bestPriceOnDateData as BestPriceRouteType[])

    const isTravelPage = window.permalinkTypeId === permalinkTypeId.travelPage
    const travelPageHasResults = isTravelPage && !!window?.bestPriceOnDateDataTravel

    const {setError} = useHandleError(false)

    useEffect(() => {
        if (isStationToStation && !stationToStationHasResults) {
            setError({error: 'bestPriceOnDateData is empty'})
        }
        if (isPortToPort && !portToPortHasResults) {
            setError({error: 'bestPriceOnDateData is empty'})
        }
    }, [])

    return (
        <ErrorBoundary shouldReload={false}>
            <>
                <CompanyCards/>
                <BestPriceOnDatePortal
                    stationToStationHasResults={stationToStationHasResults}
                    portToPortHasResults={portToPortHasResults}
                    travelPageHasResults={travelPageHasResults}
                    isTravelPage={isTravelPage}
                />
                <PortalMap className="travel-table">
                    <TravelTable/>
                </PortalMap>
                <ErrorBoundary shouldReload={false}>
                    <DepartureAndDestinationStation/>
                </ErrorBoundary>
                <ReviewsPortal/>
                <FaqPortal/>
                <GbtVehiclesPortal/>
                {window.tableOfContents && (<TableOfContentsPortal/>)}
            </>
        </ErrorBoundary>
    );
}

export default StationToStation;